import {getJSONP} from '../../api/myaxios'
import * as Cookie from 'tiny-cookie'

function encodeTk2(e) {
  return btoa(e).replace(/\+/g, "_").replace(/\//g, "~").replace(/=/g, "-").split("").reverse().join("")
}

function getGUID() {
  let t = Cookie.get("MQGUID");
  if (t)
    return t;
  getJSONP("//guids.api.mgtv.com/pc/distribute.do", {
    t: +(new Date).getTime()
  }).then(function (res) {
    if (res) {
      Cookie.set("MQGUID", res.data)
    }
  });
}

function getOS() {
  var e = navigator.userAgent.toLowerCase(),
    t = {
      ipad: /ipad/.test(e),
      iphone: /iphone/.test(e),
      android: /android/.test(e),
      win: /windows/.test(e)
    };
  for (var n in t)
    if (t[n])
      return n;
  return "other"
}

function getOSVersion() {
  var e = navigator.userAgent,
    t = getOS();
  try {
    switch (t) {
      case "ipad":
        return "ipad-" + e.match(/OS\b (.*)\b like/)[1].replace(/_/g, ".");
      case "iphone":
        return "iphone-" + e.match(/OS\b (.*)\b like/)[1].replace(/_/g, ".");
      case "android":
        return "aphone-" + e.match(/Android\b (.*)\b;/)[1];
      default:
        return "other"
    }
  } catch (e) {
  }
  return "other"
}

function getOSType() {
  switch (getOS()) {
    case "ipad":
      return 23;
    case "iphone":
      return 24;
    case "android":
    default:
      return 22
  }
}

function getTK2() {
  var atcObject = {};
  /*客户端和服务器端通过对称加密算法加解密信息包含如下，各字段用竖线（|）作为分隔符：
   did=***（设备ID：数字类型）
   uid=***  （用户ID：数字类型）
   vip=0|1  （会员身份：数字类型）
   pno=***  （端ID：数字类型）
   ver=***   （版本号：字符串）
   clit=***   （客户端系统时间：字符串）
   加密前信息明文串：
   did=xxxxx|uid=xxxxx|vip=0|pno=1000|ver=5.5.1.xxx|clit=20170726182600
   明文串通过对称加密得到密文串*/

  var tk2 = "did=|uid=" + getGUID() + "|vip=" + "0" + "|pno=1031|ver=" + 'JMCP' + "|clit=" + Math.floor(new Date().getTime() / 1000);
  atcObject.tk2 = encodeTk2(tk2);

  // 广告位、用户及设备相关信息
  let p = JSON.stringify({
    // 页面相关
    m: {p:4540},
    // 设备相关
    c: {
      type: getOSType(),
      os: getOSVersion().replace('-', ' ').replace('aphone', 'android'),
      version: 'JMCP',
      rs: window.innerWidth + '*' + window.innerHeight, // 分辨率
      ua: encodeURIComponent(window.navigator.userAgent), // user agent
      lt: 0, // 横竖屏状态 0:未知 1:竖屏 2:横屏
      ts: +(new Date()), // 请求的时间点
      cw: window.innerWidth,
      ch: window.innerHeight,
      cori: window.orientation,
      sd: window.devicePixelRatio
    },
    u: {},
    atc: atcObject
  });
  return p;
}

export function updatePlayerURL(vid, player, callback) {
  let _this = this;
  //"atc":{"tk2":"-EzM0gzM5ETM1ETP0lGbjxHMuEjL10jclZHfxMDMx0zbuBHfw0DcpZHf0IjMwAzM5ATMzATO2MjN0gDO9QWa1xXPklGZ"}
  //https://m.da.mgtv.com/m/player?_type_object=p,v&p={%22m%22:{%22p%22:4540,%22ptype%22:%22front%22,%22pu%22:%22https%3A%2F%2Fm.mgtv.com%2F%23%2Fb%2F319194%2F4184560%22},%22c%22:{%22type%22:24,%22os%22:%22iphone%205.1%22,%22version%22:%225.1.0%22,%22rs%22:%22375*603%22,%22ua%22:%22Mozilla%2F5.0%20(iPhone%3B%20CPU%20iPhone%20OS%205_1%20like%20Mac%20OS%20X)%20AppleWebKit%2F534.46%20(KHTML%2C%20like%20Gecko)%20Mobile%2F9B176%20weibo%2F4.3.2%22,%22lt%22:0,%22ts%22:1511938431867,%22cw%22:375,%22ch%22:603,%22sd%22:2},%22u%22:{%22passport%22:%22%22,%22ck%22:%22d3ae4f81-9354-4b1c-9809-5c0ac21df706%22,%22sid%22:%221511938431398%22,%22cxid%22:%2290f76kbev%22,%22isContinue%22:0},%22atc%22:{%22tk2%22:%22-EzM0gzM5ETM1ETP0lGbjxHMuEjL10jclZHfxMDMx0zbuBHfw0DcpZHf0IjMwAzM5ATMzATO2MjN0gDO9QWa1xXPklGZ%22}}&v={%22v%22:{%22url%22:%22https%3A%2F%2Fm.mgtv.com%2F%23%2Fb%2F319194%2F4184560%22,%22vip%22:0,%22uname%22:%22%22,%22ucode%22:%22%22,%22id%22:4184560,%22hid%22:319194,%22rid%22:1,%22clip_type%22:1,%22vtt%22:300,%22ispreview%22:1,%22ispay%22:1}}&callback=jsonp_9242lvvjs29i9uy
  let u = 'https://m.da.mgtv.com/m/player?_type_object=p,v&p={%22m%22:{%22p%22:4540,%22ptype%22:%22front%22,%22pu%22:%22https%3A%2F%2Fm.mgtv.com%2F%23%2Fb%2F319194%2F4184560%22},%22c%22:{%22type%22:24,%22os%22:%22iphone%205.1%22,%22version%22:%225.1.0%22,%22rs%22:%22375*603%22,%22ua%22:%22Mozilla%2F5.0%20(iPhone%3B%20CPU%20iPhone%20OS%205_1%20like%20Mac%20OS%20X)%20AppleWebKit%2F534.46%20(KHTML%2C%20like%20Gecko)%20Mobile%2F9B176%20weibo%2F4.3.2%22,%22lt%22:0,%22ts%22:1511938431867,%22cw%22:375,%22ch%22:603,%22sd%22:2},%22u%22:{%22passport%22:%22%22,%22ck%22:%22d3ae4f81-9354-4b1c-9809-5c0ac21df706%22,%22sid%22:%221511938431398%22,%22cxid%22:%2290f76kbev%22,%22isContinue%22:0},%22atc%22:{%22tk2%22:%22-EzM0gzM5ETM1ETP0lGbjxHMuEjL10jclZHfxMDMx0zbuBHfw0DcpZHf0IjMwAzM5ATMzATO2MjN0gDO9QWa1xXPklGZ%22}}&v={%22v%22:{%22url%22:%22https%3A%2F%2Fm.mgtv.com%2F%23%2Fb%2F319194%2F4184560%22,%22vip%22:0,%22uname%22:%22%22,%22ucode%22:%22%22,%22id%22:4184560,%22hid%22:319194,%22rid%22:1,%22clip_type%22:1,%22vtt%22:300,%22ispreview%22:1,%22ispay%22:1}}&callback=?';
  u = 'https://m.da.mgtv.com/m/player?_type_object=p,v&p=' + getTK2() + '&v={}';
  getJSONP(u).then(function (data) {
    if (!data) {
      return;
    }
    let dd = data.v.ets.atc;
    let t = dd.tk2, p = dd.pm2;
    getJSONP('//v5m.api.mgtv.com/remaster/uc/getSource?pm2=' + p + '&tk2=' + t + '&partId=' + vid).then(function (data) {
      var urlArray = data.data.stream.mp4Url;
      u = data.data.stream.startUrl + urlArray[0];
      if (location.protocol === 'https:') {
        u = u.replace(/http:/, 'https:')
      }
      getJSONP(u).then(function (data) {
        document.getElementById(player).setAttribute('src', data.info);
        if (callback) {
          (callback && typeof(callback) === "function") && callback();
        } else {
          document.getElementById(player).play();
        }
      });
    });
  });
}


export function pauseAllVideo() {
  const videos = document.getElementsByTagName('video');
  for (let video of videos) {
    video.pause();
  }
}





// WEBPACK FOOTER //
// ./src/tools/mgtv/video.js